export default function (value, originalValue) {
  return typeof originalValue === 'string' && originalValue === '' ?
    null
    : value
}
